import Link from 'next/link';
import { useRouter } from 'next/router';

import { getChipSlug } from 'utils/miningCalculatorStrings';

const ModelCell = (props: IModelCell) => {
  const { rowData } = props;
  const { row, accessor } = rowData;

  const router = useRouter();
  const { model } = router.query;

  const chipSlug = getChipSlug(row);
  const name: string[] = [accessor];

  if (chipSlug === model?.[0]) {
    return (
      <div className="model-cell">
        <span>{name.join(' ')}</span>
      </div>
    );
  }

  return (
    <div className="model-cell">
      <Link href={chipSlug} passHref legacyBehavior>
        <a className="link-type-underline model-cell__link">
          <span>{name.join(' ')}</span>
        </a>
      </Link>
    </div>
  );
};

export default ModelCell;
